<template>
  <div class="mobile-page">
    <!-- 1. 顶部搜索栏 -->
    <div class="search-bar">
      <input 
        type="text" 
        v-model="searchKeyword" 
        placeholder="商品名称..." 
        @input="getGoods"
      />
      <button v-if="!showScanner" @click="openScanner">扫一扫</button>
      <div v-if="showScanner">
        <div id="barcode-reader"></div>
      </div>
    </div>

    </div>

    <!-- 2. 商品列表 -->
    <div class="product-list">
      <div v-for="product in goods" :key="product.id" class="product-card">
        <div class="product-info">
          <h3>{{ product.name }}</h3>
          <p class="specs">规格：{{ product.form }}</p >
          <p class="price">售价：¥{{ product.price }}</p >
          <p class="price">¥{{ product.bidPrice }}</p >
        </div>
      </div>
    </div>
    
    <!-- 列表为空时的提示 -->
    <div v-if="goods.length === 0" class="empty-tip">
      暂无相关商品
    </div>

    <!-- 3. 分页器 -->
    <div class="pagination">
      <button @click="prevPage" :disabled="page === 1">上一页</button>
      <span>第 {{ page }} / {{ total }} 页</span>
      <button @click="nextPage" :disabled="page === total">下一页</button>
    </div>
  </div>
</template>


<script>
import util from '../../common/js/util'
import _ from 'lodash';
import '../../common/js/pinyinUtil.js'
import Cookies from 'js-cookie'
import { Html5Qrcode,Html5QrcodeSupportedFormats } from 'html5-qrcode'

import { getGoodsList} from '../../api/api';

export default {
    data() {
      return {
        goods: [],
        total: 0,
        page: 1,
        pageSize: 5,
        searchKeyword:'',
        handleKeyPress:_.debounce(this.getGoods, 100), // 500毫秒内只触发一次

        showScanner: false,
        scanner: null,
            scanLock: false,

      }
    },
    methods: {
      async openScanner() {
        this.showScanner = true
        await this.$nextTick()
        this.scanner = new Html5Qrcode('barcode-reader')
        const cfg = {
          fps: 6,
            qrbox: { width: 550, height: 240 },
            disableFlip: true,
            formats: [
              Html5QrcodeSupportedFormats.CODE_128,
              Html5QrcodeSupportedFormats.EAN_13,
              Html5QrcodeSupportedFormats.EAN_8
            ],
            videoConstraints: {
              width: { ideal: 1280 },
              height: { ideal: 720 }
            }
          
        }
        this.scanner.start({facingMode: 'environment'},cfg, (decodedText,decodedResult) => {
          if (this.scanLock) return
          this.scanLock = true
          this.searchKeyword = decodedText
          console.log(decodedText,decodedResult);
          this.getGoods();
          setTimeout(() => this.scanLock = false, 1000)
        }, () => {}).catch((error) => {
          console.log(error);
          alert('摄像头调用失败')
          this.showScanner = false
        })
      },
      async closeScanner() {
        if (!this.scanner) return
        await this.scanner.stop().catch(e=>{})
        this.scanner = null
        this.showScanner = false
      },
      beforeDestroy() {
      this.closeScanner()
      },

      //获取物料倩价列表
      getGoods() {
        let para = {
          page:this.page,
                    size:this.pageSize,
                    name:this.searchKeyword,
        };
        getGoodsList(para).then((res) => {
          let msg = res.data.message;
                  let code = res.data.code;
          if (code !== 200) {
                    this.$message({
                      message: msg,
                      type: 'error'
                    });
                  } else {
            this.goods = res.data.data.list
                      this.page = res.data.data.pageNum == 0 ? res.data.data.pageNum +1 : res.data.data.pageNum
                      this.total = res.data.data.total
                  }
        });
      },
      prevPage() {
        if (this.page > 1) {
          this.page--;
          this.getGoods();
        }
      },
      nextPage() {
        if (this.page < this.total) {
          this.page++;
          this.getGoods();
        }
      },
    },
    mounted() {
      this.getGoods();
    },
  }


</script>

<style scoped>
.mobile-page {
  width: 100vw;
  height: 50vh;
  max-width: 768px; /* 模拟手机宽度 */
  margin: 0 auto;
  padding: 16px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.search-barcode-wrap {
  width: 100%;
  max-width: 768px;
  margin: 30px auto;
}
.search-input-box {
  display: flex;
  gap: 10px;
  align-items: center;
}

.scan-btn {
  padding: 9px 16px;
  border: none;
  border-radius: 4px;
  background: #409eff;
  color: #fff;
  cursor: pointer;
}

/* 扫码弹窗遮罩 */
.scanner-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.scanner-content {
  width: 92%;
  max-width: 520px;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
}
.scan-view {
  width: 100%;
  height: 340px;
  border: 2px solid #409eff;
  margin: 12px 0;
  overflow: hidden;
}
.tip-text {
  text-align: center;
  color: #555;
  margin: 6px 0 16px;
}
.btn-group {
  text-align: center;
}
.btn-group button {
  padding: 8px 26px;
  background: #f56c6c;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}


/* 商品列表 */
.product-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.product-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
.product-info h3 {
  font-size: 48px;
  margin: 0 0 8px 0;
  color: #333;
}
.product-info .price {
  color: #e4393c;
  font-weight: bold;
  font-size: 48px;
  margin: 0 0 8px 0;
}
.product-info .specs {
  font-size: 36px;
  color: #888;
  margin: 0;
}

/* 按钮 */
.history-btn {
  padding: 8px 12px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
.history-btn:active {
  background-color: #0056b3;
}

/* 分页器 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  gap: 16px;
  color: #666;
}
.pagination button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background-color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.pagination button:disabled {
  background-color: #f0f0f0;
  color: #ccc;
  cursor: not-allowed;
}

/* 空状态 */
.empty-tip {
  text-align: center;
  color: #999;
  margin-top: 40px;
}
</style>